import { render, staticRenderFns } from "./FamilyInfo.vue?vue&type=template&id=5479bbd6&scoped=true&"
import script from "./FamilyInfo.vue?vue&type=script&lang=js&"
export * from "./FamilyInfo.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInfo.vue?vue&type=style&index=0&id=5479bbd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479bbd6",
  null
  
)

export default component.exports